import React from "react";
import styled from "styled-components";

// Square lifestyle photo with the app mini-card floating over its edge
const Wrapper = styled.div`
  position: relative;
  width: min(100%, 440px);
  /* room for the mini-card that hangs over the side */
  margin-right: ${(props) => (props.$side === "right" ? "12%" : "0")};
  margin-left: ${(props) => (props.$side === "left" ? "12%" : "0")};

  @media screen and (max-width: 48em) {
    width: min(100%, 360px);
    margin: 0 auto 3.5rem;
  }
`;

const Photo = styled.div`
  aspect-ratio: 1;
  border-radius: 32px;
  border: 6px solid #ffffff;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(10, 10, 11, 0.12);
  background: linear-gradient(145deg, #e9e6dc 0%, #dfe7e1 55%, #cfdcd5 100%);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const Idea = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 1.5rem;
  font-family: var(--fontR);
  color: #5d6b64;

  span {
    font-size: 0.6875rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.5;
    max-width: 17rem;
  }
`;

const Floating = styled.div`
  position: absolute;
  bottom: 10%;
  width: 68%;
  ${(props) => (props.$side === "right" ? "right: -24%;" : "left: -24%;")}

  @media screen and (max-width: 48em) {
    left: 50%;
    right: auto;
    bottom: -3rem;
    width: 86%;
    transform: translateX(-50%);
  }
`;

/**
 * `side` is the side the mini-card hangs over. Without `photo.src` the slot renders
 * the art-direction note instead, so the layout is final before the photos exist.
 */
const PhotoSlot = ({ photo, side = "right", children }) => (
  <Wrapper $side={side}>
    <Photo>
      {photo.src ? (
        <img src={photo.src} alt={photo.alt} width="1200" height="1200" loading="lazy" decoding="async" />
      ) : (
        <Idea>
          <span>Photo à venir</span>
          <p>{photo.idea}</p>
        </Idea>
      )}
    </Photo>
    {children && <Floating $side={side}>{children}</Floating>}
  </Wrapper>
);

export default PhotoSlot;
